import { FIND_TICKET } from "../../routes";
import customAxios from "../../customAxios";
import {
  IFindTicketInformation,
  IFindUserInformation,
} from "../../../types/common.interface";
import utils from "../../../utils";

interface iQuery {
  value: string | undefined;
  target: "province" | "city" | "company" | "gender" | "marital";
}
async function findTicket(props: IFindTicketInformation) {
  var thisUrl = FIND_TICKET;
  // if (props.page) thisUrl += `page=${props.page}`;
  // if (props.limit) thisUrl += `&limit=${props.limit}`;

  // let schoolDriverInformation;
  // if (props.companyId) {
  //   schoolDriverInformation = {
  //     "schoolDriverInformation.company": props.companyId,
  //   };
  // }

  let body: any = {
    ...props.filters,
    page: props.page,
    limit: props.limit,
    user: props._id,
    type: props.filters?.type,
    populate: "user",
  };

  // ** ---------------------------------------------------------------------------------------------------------------------
  // ** =====================================================================================================================
  // **                                                      Local Functions
  // ** =====================================================================================================================
  // ** ---------------------------------------------------------------------------------------------------------------------

  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                            Searching For SuperAgent
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------

  if (props?.search?.value) {
    body = {
      ...body,
      search: {
        searchMode: props.search.base,
        searchValue: props.search.value,
      },
    };
  }

  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                                    Filtering For SuperAgent
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------
  // if (props?.filters) {
  //   const { province, city, company, marital, gender } = props.filters;

  //   body = {
  //     query: {
  //       ...body.query,
  //       "schoolDriverInformation.province": province?._id,
  //       "schoolDriverInformation.city": city?._id,
  //       "schoolDriverInformation.company": company?._id,
  //       gender: gender?.value,
  //       "schoolDriverInformation.marital": marital?.value,
  //     },
  //   }; // if (province) query({ target: "province", value: province?._id });
  //   // if (city) query({ target: "city", value: city?._id });
  //   // if (company) query({ target: "company", value: company?._id });
  //   // if (marital) query({ target: "marital", value: marital?.value });
  //   // if (gender) query({ target: "gender", value: gender?.value });
  // }

  try {
    return (await customAxios.post(thisUrl, body)).data;
  } catch (error: any) {
    console.error({ GET_ALL_TICKET: error });
  }
}

export default findTicket;
